import React from 'react';
import styles from './UpModal.module.css';

const Modal = ({ 
  isOpen, 
  onClose, 
  tabs = [], 
  activeTab, 
  onTabChange, 
  children,
  className = '',
  showCloseButton = true 
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div 
        className={`${styles.modal} ${className}`} 
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.modalHeader}>
          {/* Рендер табов если они переданы */}
          {tabs.length > 0 && (
            <div className={styles.tabsContainer}>
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  className={`${styles.tabButton} ${
                    activeTab === tab.key ? styles.activeTab : ''
                  }`}
                  onClick={() => onTabChange(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          )}
          
          {/* Кнопка закрытия */}
          {showCloseButton && (
            <button className={styles.closeButton} onClick={onClose}>
              ✕
            </button>
          )}
        </div>

        <div className={styles.modalContent}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;